import { Component, Input } from '@angular/core';
import { ResponsiveService, SpacingValue } from '@frk/eds-components';
import { SignInService } from '@services';
import { Observable } from 'rxjs';

@Component({
  selector: 'ft-sign-in-bar',
  templateUrl: './sign-in-bar.component.html',
  styleUrls: ['./sign-in-bar.component.scss'],
})
export class SignInBarComponent {
  /**
   * signInBarText
   * text on sign in bar
   */
  @Input() signInBarTextLabel: string;

  /**
   * fullPageWidth
   * Toggles grid wraapper when sign in bar
   * runs across full width of page e.g. below a banner
   */
  @Input() isFullPageWidth = false;

  @Input() spacingBottom: SpacingValue = 'md';

  public isMobile$: Observable<boolean>;

  constructor(
    private responsiveService: ResponsiveService,
    private signInService: SignInService
  ) {
    // Listen for responsive changes
    this.isMobile$ = this.responsiveService.isMobile$();
  }

  /**
   * launchSignIn
   * Launches signin modal
   */
  public launchSignIn() {
    this.signInService.showSignInModal();
  }
}
